"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCloudViewerUrl = void 0;
var constants_1 = require("../../utils/constants");
var hasFolderId_1 = require("../../utils/hasFolderId");
var IdValidation_1 = require("../../utils/IdValidation");
var parseAttachDetails_1 = require("../../utils/parseAttachDetails");
var parseUrl_1 = require("../../utils/parseUrl");
var prepareRegExps_1 = require("../../utils/prepareRegExps");
var regexps_1 = require("../../utils/regexps");
var validateQueryParams = function (queryParams, attachType, correctQueryParams) {
    /** Проверяем емейл пользователя */
    var xEmail = queryParams.get(constants_1.ParamsKeys.XEmail);
    var correctXEmail = correctQueryParams[constants_1.ParamsKeys.XEmail];
    if (correctXEmail && xEmail !== correctXEmail) {
        return {
            result: false,
            error: constants_1.Errors.Email,
        };
    }
    /** Проверяем обратный урл */
    var backUrl = queryParams.get(constants_1.ParamsKeys.BackUrl);
    var correctBackUrl = correctQueryParams[constants_1.ParamsKeys.BackUrl];
    if (correctBackUrl && backUrl !== correctBackUrl) {
        return {
            result: false,
            error: constants_1.Errors.BackUrl,
        };
    }
    /** Проверяем айди папки */
    if (attachType === constants_1.AttachType.Temporary || !(0, hasFolderId_1.hasFolderId)(correctQueryParams)) {
        return { result: true };
    }
    var folderId = queryParams.get(constants_1.ParamsKeys.FolderId);
    var correctFolderId = correctQueryParams[constants_1.ParamsKeys.FolderId];
    if (correctFolderId && folderId !== correctFolderId) {
        return {
            result: false,
            error: constants_1.Errors.FolderId,
        };
    }
    return { result: true };
};
/** Валидация урла облачного просмотрщика */
var validateCloudViewerUrl = function (url, attachType, correctParams, regExps) {
    if (regExps === void 0) { regExps = regexps_1.defaultRegExps; }
    var _a = (0, prepareRegExps_1.prepareRegExps)(regExps), attachesRegExps = _a.attachesRegExps, messageIdsRegExps = _a.messageIdsRegExps, attachPathReg = _a.attachPathReg, urlPartsReg = _a.urlPartsReg, emlFormatId = _a.emlFormatId;
    var result = (0, parseUrl_1.parseUrl)(url, urlPartsReg);
    if (!result) {
        return {
            result: false,
            error: constants_1.Errors.Url,
        };
    }
    var host = result.host, attachPath = result.attachPath, queryParams = result.queryParams;
    var correctHost = correctParams.correctHost, correctAttachId = correctParams.correctAttachId, correctMessageId = correctParams.correctMessageId, correctQueryParams = correctParams.correctQueryParams;
    /** Проверяем валидность хоста */
    if (host !== correctHost) {
        return {
            result: false,
            error: constants_1.Errors.Host,
        };
    }
    var decodedIds;
    try {
        decodedIds = decodeURIComponent(attachPath);
    }
    catch (error) {
        return {
            result: false,
            error: constants_1.Errors.Decode,
        };
    }
    var parsedData = (0, parseAttachDetails_1.parseAttachDetails)(decodedIds, attachPathReg, emlFormatId);
    if (parsedData === null) {
        return {
            result: false,
            error: constants_1.Errors.Ids,
        };
    }
    var messageId = parsedData.messageId, encodedAttachId = parsedData.encodedAttachId;
    /** Проверяем валидность айди аттача */
    var isAttachIdValid = (0, IdValidation_1.validateAttachId)(attachType, encodedAttachId, attachesRegExps);
    if (!isAttachIdValid || encodedAttachId !== correctAttachId) {
        return {
            result: false,
            error: constants_1.Errors.AttachId,
        };
    }
    /** Проверяем валидность айди письма */
    var isMessageIdValid = (0, IdValidation_1.validateMessageId)(attachType, messageId, messageIdsRegExps);
    if (messageId !== correctMessageId || !isMessageIdValid) {
        return {
            result: false,
            error: constants_1.Errors.MessageId,
        };
    }
    /** Проверяем валидность гет параметров */
    return validateQueryParams(queryParams, attachType, correctQueryParams);
};
exports.validateCloudViewerUrl = validateCloudViewerUrl;
//# sourceMappingURL=validate.js.map